/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import PropertyCard from 'material/embeds/propertycard/propertycard';
// content types
import QuestionProperties from 'pages/dashboard/embeds/management/customize/cardproperties/questionproperties/questionproperties_container';
import StoryProperties from 'pages/dashboard/embeds/management/customize/cardproperties/storyproperties/storyproperties_container';
// style
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/cardproperties/cardproperties_styles';



/* ========== ~~~~~~~~~~ EMBED CARD PROPERTIES ~~~~~~~~~~ ========== */
const CardProperties = (props) => {
    const renderContentType = () => {
        switch (props.contentType) {
            case 'story':
                return <StoryProperties />;
            case 'quiz':
            case 'poll':
            default:
                return <QuestionProperties contentType={props.contentType} />
        }
    }
    const showPlacement = () => props.location === 'in-content' ? 'incontent' : 'rail';
    const title = props.contentType ? props.contentType.charAt(0).toUpperCase() + props.contentType.slice(1) : 'Quiz'
    return (
        <div className={`cardproperties ${props.classes.cardproperties} ${showPlacement()} ${props.noLiveContents ? 'greyOut' : ''}`}>
            <PropertyCard title={`${title} Formatting`} properties={renderContentType()}/>
        </div >
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CardProperties);
